import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common_it from '../translations/it/common.json';
import common_en from '../translations/en/common.json';

i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    IT: {
      translations: common_it
    },
    EN: {
      translations: common_en
    }
  },
  interpolation: { escapeValue: false }, // React already does escaping
  lng: localStorage.getItem('lng') || 'IT',
  ns: ['translations'],
  defaultNS: 'translations',

  react: {
    wait: true
  }
});

export default i18n;
